import { z } from 'zod';
const ipAddress = z.union([z.ipv4(), z.ipv6()]);
/**
 * Network addresses an owner client reports in its relay `hello` (`system.network`).
 * Presentation only: nothing here grants, narrows or widens a capability. The relay
 * handshake and the store both validate with this one schema.
 */
export const ownerDeviceNetworkSchema = z
    .object({
    primaryIpv4: z.ipv4().optional(),
    primaryIpv6: z.ipv6().optional(),
    addresses: z
        .array(z
        .object({
        interface: z.string().regex(/^[A-Za-z0-9_.:@-]{1,32}$/),
        address: ipAddress,
        prefix: z.number().int().min(0).max(128),
    })
        .strict()
        .refine((entry) => !z.ipv4().safeParse(entry.address).success || entry.prefix <= 32, {
        message: 'An IPv4 prefix is at most 32 bits.',
        path: ['prefix'],
    }))
        .max(16)
        .optional(),
})
    .strict();
//# sourceMappingURL=device-network.js.map